export default __webpack_public_path__ + "static/media/dislike.39d84933.png";